var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSampleDataCoachCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 148,
    viewBox: "0 0 288 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H288V148H0V0Z",
    fill: "#264468"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_891",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 288,
    height: 148
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H288V148H0V0Z",
    fill: "#264468"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.5 155C276.5 191.358 249.237 220.5 216 220.5C182.763 220.5 155.5 191.358 155.5 155C155.5 118.642 182.763 89.5 216 89.5C249.237 89.5 276.5 118.642 276.5 155Z",
    stroke: "#7BA7BC",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5 -6C184.5 22.4005 159.248 45.5 128 45.5C96.7517 45.5 71.5 22.4005 71.5 -6C71.5 -34.4005 96.7517 -57.5 128 -57.5C159.248 -57.5 184.5 -34.4005 184.5 -6Z",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleDataCoachCardBg);
export default __webpack_public_path__ + "static/media/sample-data-coach-card-bg.820b0589bbd06b840c93a1f5c4bd908f.svg";
export { ForwardRef as ReactComponent };